<template>
  <div class="display">
    <v-alert v-show="true" color="primary" value="true" outline>
      Ces réglages affectent le contenu du widget lorsqu'au moins un agent est connecté et en ligne sur le site <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <!-- Indique que la chat est coupé en Front -->
    <v-alert v-show="!onOff" color="secondary" icon="priority_high" value="true" outline>
      Attention, les conversations par chat son coupées côté internaute. Cela peut également affecter la liste des visiteurs en ligne sur la section Trafic/Visiteurs. <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <!-- Indique si la licence n'a pas l'option Mirroring -->
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      {{ $t('warningCobrowsingDisabled') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <!-- Indique si le site est en http et donc pas possible d'activer le cobrowsing -->
    <v-alert v-show="alertSSL" color="warning" icon="priority_high" value="true" outline>
      {{ $t('warningCobrowsingHttp') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>

    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
	
    <div v-else>
      <!-- ON / OFF -->
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-switch 
                :label="onOff ? 'CHAT ON' : 'CHAT OFF'" 
                v-model="onOff"
                light
                color="primary"
                @click.native="!onOff ? warningChatOff = true : ''"
                :disabled="testBrideStatus('parametre_chat')"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      
      <v-expansion-panel>
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_invitation')"
        >         
          <div slot="header">
            <v-icon class="mr-2 primary--text">announcement</v-icon>
            {{ $t('autochatTitle') }}
            <!--<code>{{ invit.active ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('invit.active')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="invit.active">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="invit.active">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <!-- Envoyer automatiquement un message chat -->
                  <v-switch 
                    :label="$t('autochatTitleLabel')"
                    v-model="invit.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-select
                    v-model="invit.lang"
                    :items="langs"
                    :label="$t('language') | cap"
                    return-object
                    dense
                    :disabled="!invit.active"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md9>
                  <!-- Contenu du message d'attente -->
                  <v-text-field 
                    v-model="invit.content"
                    :label="$t('content') | cap"
                    required
                    :disabled="!invit.active" 
                    @input="updateInvit()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 v-show="invit.active">
                  <div>{{ $t('triggerConditionTime') }}</div>
                  <v-slider 
                    v-model="invit.delay"
                    thumb-label
                    :min="0"
                    :max="300"
                  ></v-slider>
                  <span>{{ invit.delay }} sec.</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 v-show="invit.active">
                  <div>{{ $t('triggerConditionUrl') }}</div>
                  <v-switch 
                    :label="$t('restrictFewUrLs')"
                    v-model="invit.urlonoff"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 v-show="invit.active">
                  <v-text-field 
                    v-model="invit.url"
                    :label="$t('containsString')"
                    :disabled="!invit.urlonoff" 
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Formulaire -->  
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_formprechat')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">assignment</v-icon>
            {{$t('prechatTitle')}}
            <!--<code>{{ prechat.active ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('prechat.active')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="prechat.active">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="prechat.active">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- Afficher le formulaire pré-chat -->
                  <v-switch 
                    :label="$t('prechatTitleLabel')"
                    v-model="prechat.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <!-- Titre du formulaire -->
                  <v-text-field 
                    v-model="prechat.title"
                    :label="$t('title') | cap"
                    required
                    v-validate="'required'"
                    data-vv-name="prechat.title"
                    :error="wzErrors.has('prechat.title')"
                    :error-messages="wzErrors.collect('prechat.title')"
                    :disabled="!prechat.active"  
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <!-- Sous-titre -->
                  <v-text-field 
                    v-model="prechat.subtitle"
                    :label="$t('subTitle') | cap"
                    :disabled="!prechat.active"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <!-- Texte du bouton -->
                  <v-text-field 
                    v-model="prechat.button"
                    :label="$t('buttonText') | cap"
                    required
                    v-validate="'required'"
                    data-vv-name="prechat.button"
                    :error="wzErrors.has('prechat.button')"
                    :error-messages="wzErrors.collect('prechat.button')"
                    :disabled="!prechat.active"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex v-for="(field, a) in itemsFields" :key="a" xs6 sm3 md2>
                  <v-checkbox
                    :disabled="!prechat.active"
                    :label="field.text"
                    v-model="prechat.fields"
                    :value="field.value"
                    class="primary--text"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- premier message-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_premiermessage')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">chat</v-icon>
            {{ $t('firstAutoMessage') | cap }}
            <!--<code>{{ msgAuto.active ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('msgAuto.active')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="msgAuto.active">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="msgAuto.active">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- Premier message automatique (bulle chat) -->
                  <v-switch 
                    :label="$t('enable') | cap"
                    v-model="msgAuto.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md6>
                  <!-- Titre du formulaire -->
                  <v-text-field 
                    v-model="msgAuto.content"
                    :label="$t('title') | cap"
                    required
                    v-validate="'required'"
                    data-vv-name="msgAuto.content"
                    :error="wzErrors.has('msgAuto.content')"
                    :error-messages="wzErrors.collect('msgAuto.content')"
                    :disabled="!msgAuto.active"  
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
		<!-- premier message RGPD-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_premiermessage')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">chat</v-icon>
Afficher la mention RGPD au démarage du chat
            <v-tooltip left 
              @click.native.stop="switchValue('rgpdOnOff')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="rgpdOnOff">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="rgpdOnOff">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- Premier message automatique (bulle chat) -->
                  <v-switch 
                    :label="$t('enable') | cap"
                    v-model="rgpdOnOff"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- reponse auto-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_reponseauto')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">question_answer</v-icon>
            {{ $t('autoResponse') | cap }}
            <!--<code>{{ answerAuto.active ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('answerAuto.active')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="answerAuto.active">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="answerAuto.active">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- Activer réponse automatique -->
                  <v-switch 
                    :label="$t('enable') | cap"
                    v-model="answerAuto.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    v-model="answerAuto.lang"
                    :items="langs"
                    :label="$t('language') | cap"
                    return-object
                    :disabled="!answerAuto.active"  
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md9>
                  <!-- Contenu du message d'attente -->
                  <v-text-field 
                    v-model="answerAuto.content"
                    :label="$t('content') | cap"
                    required
                    :disabled="!answerAuto.active" 
                    @input="updateMessages()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- editeur de lead-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_editlead')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">loyalty</v-icon>
            {{ $t('leadEditor') | cap }}
            <!--<code>{{ customLead.active ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('customLead.active')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="customLead.active">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="customLead.active">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <!-- Modifier le formulaire existant -->
                  <v-switch 
                    :label="$t('enable') | cap"
                    v-model="customLead.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
              <v-flex xs12 md6 v-show="customLead.active">
                <v-subheader>{{ $t('basicFields') | cap }}</v-subheader>
                <v-layout row wrap v-for="(field, i) in customLeadClassicFields" :key="i">
                  <v-flex sm3>
                    <v-checkbox 
                      :disabled="!customLead.active"
                      :label="field.text"
                      v-model="customLead.info"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex> 
                  <v-flex sm3>
                    <v-checkbox 
                      :disabled="!customLead.active"
                      label="Obligatoire"
                      v-model="customLead.info_required"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-subheader>{{ $t('yourCustomFields') | cap }}</v-subheader>
                <v-layout row wrap v-for="(field, k) in customFields" :key="field.value">
                  <v-flex>
                    <v-checkbox 
                      :disabled="!customLead.active"
                      :label="field.text"
                      v-model="customLead.info"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex> 
                </v-layout>
                <v-btn @click="showDialogCreate = true" color="accent" dark>
                  {{ $t('add') }} {{ $tc('fields', 1, {count: ''}) }}
                  <v-icon right>add</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 v-show="customLead.active">
                <v-subheader>{{ $t('basicTags') | cap }}</v-subheader>
                <v-layout row wrap v-for="(field, j) in customLeadClassicMotifs" :key="field.value">
                  <v-flex sm3>
                    <v-checkbox 
                      :disabled="!customLead.active"
                      :label="field.text"
                      v-model="customLead.motifs"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex> 
                </v-layout>
                <v-subheader>{{ $t('yourCustomTags') | cap }}</v-subheader>
                <v-layout row wrap v-for="(field, l) in customMotifs" :key="field.value">
                  <v-flex>
                    <v-checkbox 
                      :disabled="!customLead.active"
                      :label="field.text"
                      v-model="customLead.motifs"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex> 
                </v-layout>
                <v-btn @click="showDialogMotif = true" color="accent" dark>
                  {{ $t('add') }} {{ $tc('tags', 1, {count: ''}) }}
                  <v-icon right>add</v-icon>
                </v-btn>
              </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- istyping-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_istyping')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">keyboard</v-icon>
            IsTyping 
            <!--<code>{{ isTyping ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('isTyping')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="isTyping">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="isTyping">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <!-- Activer le isTyping -->
                  <v-switch 
                    :label="$t('enable') | cap"
                    v-model="isTyping"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Demande de géolocalisation -->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_apercu_geoloc')"
        >
          <div slot="header">
            <v-icon class="mr-2 primary--text">location_on</v-icon>
            {{ $t("locationRequest") | cap }}
            <!--<code>{{ ask_geoloc ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('ask_geoloc')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="ask_geoloc">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="ask_geoloc">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card>
            <v-card-text>
              <v-switch v-model="ask_geoloc" :label="$t('locationRequest')" color="primary"></v-switch>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- extension iframe-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_iframe')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">extension</v-icon>
            Extension Iframe
            <!--<code>{{ extensionEnabled ? $t("yes") : $t("no") }}</code>-->
            <v-tooltip left 
              @click.native.stop="switchValue('extensionEnabled')"
            >
              <template slot="activator">
                <v-icon class="infos" color="primary" dark v-if="extensionEnabled">play_circle_filled</v-icon>
                <v-icon class="infos" color="grey primary--text" dark v-else>pause_circle_filled</v-icon>
              </template>
              <span v-if="extensionEnabled">Cliquer pour désactiver</span>
              <span v-else>Cliquer pour activer</span>
            </v-tooltip>
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <!-- Activer l'extension Iframe -->
                  <v-switch
                    :label="$t('enable') | cap"
                    v-model="extensionEnabled"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <!-- URL de l'extension Iframe -->
                  <v-text-field
                    label="URL"
                    v-model="extensionUrl"
                    light
                    color="primary"
                    persistent-hint
                    hint="Inclusion de votre CRM ou tout autre page dans la fiche du visiteur"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-subheader>Ajout de variables Target First dans l'URL</v-subheader>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <!-- Ajout des variables disponibles pour l'URL -->
                  <v-btn
                    flat
                    color="accent"
                    @click="extensionUrl += '{{visiteurID}}'"
                  >
                    Id Visiteur
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- cobrowsing/mirroring-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_cobrowsing_cobrowsing') && testBrideStatus('parametre_cobrowsing_mirroring')"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">book_online</v-icon>Screen Sharing</div>
          <v-card class="mb-3">
            <v-card-text>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="onOffCobrowsing ? $t('cobrowsing') + ' ' + 'ON' : $t('cobrowsing') + ' ' + 'OFF' " 
                  v-model="onOffCobrowsing"
                  light
                  color="primary"
                  :hint="$t('descCobrowsing')"
                  persistent-hint
                  :disabled="testBrideStatus('parametre_cobrowsing_cobrowsing')"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="onOffMirroring ? $t('mirroring') + ' ' + 'ON' : $t('mirroring') + ' ' + 'OFF'" 
                  v-model="onOffMirroring"
                  light
                  color="primary"
                  :hint="$t('descMirroring')"
                  persistent-hint
                  :disabled="testBrideStatus('parametre_cobrowsing_mirroring')"
                ></v-switch>
              </v-flex>
            </v-layout>
            
          </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      
      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="postOptions()"
        >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>
      
      <v-dialog v-model="showDialogCreate" max-width="290">
        <v-card>
          <v-card-title class="primary white--text">
            {{ $t('add') }}| cap  {{ $tc('fields', 1, {count: ''}) }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              v-model="newField"
              required
              :label="$t('title') | cap"
              counter 
              max="32" 
              v-validate="'max:32'" 
              data-vv-name="newFieldName"
              @keyup.native.enter="submitDialogCreate" >
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" flat @click.native="submitDialogCreate">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDialogMotif" max-width="290">
        <v-card>
          <v-card-title class="primary white--text">
            {{ $t('add') | cap }} {{ $tc('tags', 1, {count: ''}) }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              v-model="newMotif"
              required
              :label="$t('title') | cap"
              counter 
              max="32" 
              v-validate="'max:32'" 
              data-vv-name="newFieldName"
              @keyup.native.enter="submitDialogMotif" >
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialogMotif = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" flat @click.native="submitDialogMotif">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warningChatOff" max-width="390">
        <v-card>
          <v-card-title class="primary white--text">
            Attention, vous êtes sur le point de couper le chat du côté Visiteur (sur le site web). Les internautes ne pourrons plus discuter avec les téléconseillers (même s'ils sont en ligne) et aucune invitation par chat ne sera envoyée.
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="warningChatOff = false">Continuer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog Infos -->
      <wz-dialog-infos
        @fermeDialog="fermeDialogInfos"
        :titleDialog="titleDialog"
        :contentDialog="contentDialog"
      >
      </wz-dialog-infos>

      <!-- dialog progress bar installation -->
      <wz-dialog-progress
        @fermeDialogProgress="fermeDialogProgress"
        :dialogProgress="dialogProgress"
        :etape=3
      >
      </wz-dialog-progress>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      onOff: true,
      rgpdOnOff: true,
      titleDialog: '',
      contentDialog: '',
      prechat: {
        active: false,
        title: '',
        subtitle: '',
        button: '',
        fields: []
      },
      msgAuto: {
        active: false,
        content: ''
      },
      warningChatOff: false,
      invit: {
        active: false,
        content: '',
        lang: 'FR',
        urlonoff: '0',
        url: '',
        delay: '0'
      },

      answerAuto: {
        active: false,
        lang: null,
        content: ''
      },
      messages: {},
      invits: {},

      isTyping: false,

      extensionEnabled: false,
      extensionUrl: '',

      langs: [
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ],

      itemsFields: [
        { text: 'Prénom', value: 'fname' },
        { text: 'Nom', value: 'lname' },
        { text: 'Téléphone', value: 'tel' },
        { text: 'Email', value: 'email' },
        { text: 'Société', value: 'company' },
        { text: 'Code postal', value: 'zip' },
        { text: 'Question', value: 'question' }
      ],
      customLeadClassicFields: [
        { text: 'Civilité', value: 'gender' },
        { text: 'Nom', value: 'lname' },
        { text: 'Prénom', value: 'fname' },
        { text: 'Commentaire', value: 'comment' },
        { text: 'Email', value: 'email' },
        { text: 'Téléphone', value: 'tel' },
        { text: 'Société', value: 'company' },
        { text: 'URL', value: 'url' }
      ],

      customLeadClassicMotifs: [
        { text: 'Support', value: 'support' },
        { text: 'Prospect', value: 'lead' },
        { text: 'Vente', value: 'sale' },
        { text: 'Devis', value: 'devis' },
        { text: 'Réservation', value: 'resa' },
        { text: 'Contact', value: 'contact' }
      ],

      customFields: [],
      newField: '',
      customMotifs: [],
      newMotif: '',
      ask_geoloc: '',
      customLead: {
        active: false,
        motifs: [],
        motifs_type: [],
        info: [],
        info_required: []
      },

      alert: false,
      alertSSL: false,
      onOffMirroring: false,
      onOffCobrowsing: false,

      // loaders
      loadingGet: false,
      loadingPost: false,
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      showDialogMotif: false,
      dialogProgress: false
    }
  },

  created () {
    this.getOptions()
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_chat'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_chat'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  mounted () {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },

  methods: {
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },
    updateMessages () {
      this.messages[this.answerAuto.lang.value] = this.answerAuto.content
    },
    updateInvit () {
      this.invits[this.invit.lang.value] = this.invit.content
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
      // console.log('resultat', resultat)
    },

    getOptions () {
      if (this.$store.state._Sites.siteSelected.LIC_COBROWSING_ACTIVATED !== '1') {
        this.alert = true
        this.alertSSL = false
        return
      } else {
        if (this.$store.state._Sites.siteSelected.LIC_URL.indexOf('https://') === -1) {
          this.alertSSL = true
        }
      }
      this.alert = false
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_chat.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          response.data.DSK_PRECHAT_CUSTOM =
            response.data.DSK_PRECHAT_CUSTOM || '{}'
          this.prechat = _.merge(
            { active: response.data.DSK_PRECHAT_ONOFF === '1' },
            JSON.parse(response.data.DSK_PRECHAT_CUSTOM)
          )
          this.onOffMirroring = (response.data.DSK_MIRRORING === '1')
          this.onOffCobrowsing = (response.data.DSK_COBROWSING === '1')
          if (response.data.DSK_CUSTOM_LEAD_FORM === '') {
            this.customLead = {
              active: false,
              motifs: ['support', 'lead', 'sale', 'devis', 'resa', 'contact'],
              motifs_type: 'multiple',
              info: [
                'gender',
                'lname',
                'fname',
                'comment',
                'email',
                'tel',
                'company',
                'url'
              ],
              info_required: ['email']
            }
          } else {
            this.customLead = JSON.parse(response.data.DSK_CUSTOM_LEAD_FORM)
          }
          for (let i = 0; i < this.customLead.info.length; ++i) {
            let fielld = this.customLead.info[i]
            if (
              fielld !== 'gender' &&
              fielld !== 'lname' &&
              fielld !== 'fname' &&
              fielld !== 'comment' &&
              fielld !== 'email' &&
              fielld !== 'tel' &&
              fielld !== 'company' &&
              fielld !== 'url'
            ) {
              this.customFields.push({ text: fielld, value: fielld })
            }
          }
          this.customMotifs = []
          for (let i = 0; i < this.customLead.motifs.length; ++i) {
            let fielld = this.customLead.motifs[i]
            if (
              fielld !== 'support' &&
              fielld !== 'lead' &&
              fielld !== 'sale' &&
              fielld !== 'devis' &&
              fielld !== 'resa' &&
              fielld !== 'contact'
            ) {
              this.customMotifs.push({ text: fielld, value: fielld })
            }
          }
          this.msgAuto.active = response.data.DSK_FIRSTMSG_ONOFF === '1'
          this.msgAuto.content = response.data.DSK_FIRSTMSG_MSG || ''

          this.invit.active = response.data.DSK_AUTOCHAT_ONOFF === '1'
          this.invit.delay = response.data.DSK_AUTOCHAT_DELAY || ''
          this.invit.lang = _.clone(this.langs[0]) || ''
          this.invit.urlonoff = response.data.DSK_AUTOCHAT_URL_ONOFF === '1'
          this.invit.url = response.data.DSK_AUTOCHAT_URL || ''
          this.invits = JSON.parse(response.data.DSK_AUTOCHAT_MESSAGE) || {}

          this.answerAuto.active = response.data.DSK_AUTOANSWER_ONOFF === '1'
          this.answerAuto.lang = _.clone(this.langs[0]) || ''
          this.messages = JSON.parse(response.data.DSK_AUTOANSWER_MSG) || {}
          this.ask_geoloc = response.data.DSK_ASK_GEOLOC_ONOFF === '1'
          this.isTyping = response.data.DSK_SUPERISTYPING === '1'

          this.extensionEnabled = response.data.DSK_EXTENSION_ONOFF === '1'
          this.extensionUrl = response.data.DSK_EXTENSION_URL

          this.onOff = response.data.LIC_CHAT_ACTIVATED === '1'
          this.rgpdOnOff = response.data.DSK_RGPD_ONOFF === '1'
        })
        .catch(_ => {
          // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
        })
        .then(_ => {
          this.loadingGet = false
        })
    },
    submitDialogCreate () {
      if (this.newField !== '') {
        this.customFields.push({ text: this.newField, value: this.newField })
        this.customLead.info.push(this.newField)
      }
      this.showDialogCreate = false
    },
    submitDialogMotif () {
      if (this.newMotif !== '') {
        this.customMotifs.push({ text: this.newMotif, value: this.newMotif })
        this.customLead.motifs.push(this.newMotif)
      }
      this.showDialogMotif = false
    },
    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_CHAT')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append(
        'LIC_ID',
        this.$store.state._Sites.siteSelected.LIC_ID
      )
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      dataToPost.append('LIC_CHAT_ACTIVATED', this.onOff ? '1' : '0')

      dataToPost.append('DSK_PRECHAT_ONOFF', this.prechat.active ? '1' : '0')
      let custom = _.clone(this.prechat)
      delete custom.active // supprime la clé 'active' de la colonne à mettre à jour
      dataToPost.append('DSK_PRECHAT_CUSTOM', JSON.stringify(custom))
      dataToPost.append('DSK_FIRSTMSG_ONOFF', this.msgAuto.active ? '1' : '0')
      dataToPost.append('DSK_FIRSTMSG_MSG', this.msgAuto.content)
      dataToPost.append('DSK_AUTOANSWER_ONOFF', this.answerAuto.active ? '1' : '0')
      dataToPost.append('DSK_AUTOANSWER_MSG', JSON.stringify(this.messages))
      dataToPost.append('DSK_AUTOCHAT_ONOFF', this.invit.active ? '1' : '0')
      dataToPost.append('DSK_AUTOCHAT_MESSAGE', JSON.stringify(this.invits))
      dataToPost.append('DSK_AUTOCHAT_DELAY', this.invit.delay)
      dataToPost.append('DSK_AUTOCHAT_URL_ONOFF', this.invit.urlonoff ? '1' : '0')
      dataToPost.append('DSK_AUTOCHAT_URL', this.invit.url)
      dataToPost.append('DSK_SUPERISTYPING', this.isTyping ? '1' : '0')
      dataToPost.append('DSK_MIRRORING', this.onOffMirroring ? '1' : '0')
      dataToPost.append('DSK_COBROWSING', this.onOffCobrowsing ? '1' : '0')
      dataToPost.append('DSK_ASK_GEOLOC_ONOFF', this.ask_geoloc ? '1' : '0')
      dataToPost.append('DSK_RGPD_ONOFF', this.rgpdOnOff ? '1' : '0')
      dataToPost.append('DSK_CUSTOM_LEAD_FORM', JSON.stringify(this.customLead))
      dataToPost.append(
        'DSK_EXTENSION_ONOFF',
        this.extensionEnabled ? '1' : '0'
      )
      dataToPost.append('DSK_EXTENSION_URL', this.extensionUrl)
      this.loadingPost = true
      this.axios
        .post('post/settings_chat.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          let siteUpdate = _.clone(this.$store.state._Sites.siteSelected)
          siteUpdate.DSK_CUSTOM_LEAD_FORM = this.customLead
          siteUpdate.DSK_FIRSTMSG_ONOFF = this.msgAuto.active ? '1' : '0'
          siteUpdate.DSK_FIRSTMSG_MSG = this.msgAuto.content
          siteUpdate.DSK_EXTENSION_ONOFF = this.extensionEnabled ? '1' : '0'
          siteUpdate.DSK_EXTENSION_URL = this.extensionUrl
          this.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate)
          this.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate)
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    switchValue (lequel) {
      if (lequel === 'invit.active') {
        this.invit.active = !this.invit.active
      }
      if (lequel === 'prechat.active') {
        this.prechat.active = !this.prechat.active
      }
      if (lequel === 'msgAuto.active') {
        this.msgAuto.active = !this.msgAuto.active
      }
      if (lequel === 'answerAuto.active') {
        this.answerAuto.active = !this.answerAuto.active
      }
      if (lequel === 'customLead.active') {
        this.customLead.active = !this.customLead.active
      }
      if (lequel === 'isTyping') {
        this.isTyping = !this.isTyping
      }
      if (lequel === 'ask_geoloc') {
        this.ask_geoloc = !this.ask_geoloc
      }
      if (lequel === 'extensionEnabled') {
        this.extensionEnabled = !this.extensionEnabled
      }
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    'answerAuto.lang': function (val) {
      this.answerAuto.content = this.messages[val.value]
    },
    'invit.lang': function (val) {
      this.invit.content = this.invits[val.value]
    },
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Chat.vue